export default "__VITE_ASSET__YtrffQ4c__"